import { render, staticRenderFns } from "./TheScores.vue?vue&type=template&id=89ae59d8&scoped=true&"
import script from "./TheScores.vue?vue&type=script&lang=js&"
export * from "./TheScores.vue?vue&type=script&lang=js&"
import style0 from "./TheScores.vue?vue&type=style&index=0&id=89ae59d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ae59d8",
  null
  
)

export default component.exports